class RoRelatedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (! this.dataset.ak) {
      console.error('Related products: API key is missing');
      return
    }

    if (! this.dataset.type) {
      console.warn('Related products: no type specified');
      return;
    }

    this.fetchWhenConsentApproved();
  }

  fetchWhenConsentApproved() {
    if (this.relatedProductsLoaded) {
      return;
    }

    const loadRecommendations = () => {
      if (this.relatedProductsLoaded || typeof Clerk !== 'function') {
        return;
      }

      this.relatedProductsLoaded = true;
      this.fetch();
    };

    if (typeof Clerk === 'function') {
      loadRecommendations();
      return;
    }

    const onClerkReady = () => {
      loadRecommendations();
      window.removeEventListener('ro:clerk-ready', onClerkReady);
      window.removeEventListener('ro:cookie-consent-updated', onConsentUpdated);
    };

    const onConsentUpdated = (event) => {
      if (event?.detail?.clerkConsentApproved === true && typeof Clerk === 'function') {
        loadRecommendations();
        window.removeEventListener('ro:clerk-ready', onClerkReady);
        window.removeEventListener('ro:cookie-consent-updated', onConsentUpdated);
      }
    };

    window.addEventListener('ro:clerk-ready', onClerkReady);
    window.addEventListener('ro:cookie-consent-updated', onConsentUpdated);
  }

  fetch() {
    const queryObj = {
      key: this.dataset.ak,
      limit: 4,
      attributes: ['handle'],
      exclude: this.dataset.productId ? [this.dataset.productId] : null,
      products: this.dataset.productId ? [this.dataset.productId] : null,
    }

    const productGender = this.dataset.productGender;
    if (productGender) {
      queryObj.filter = `gender = ${productGender}`;
    }

    Clerk(
      'call',
      this.dataset.type,
      queryObj,
      function (response) {
        const handles = response.product_data.map((x) => x.handle);
        this.loadSection(handles);
      }.bind(this),
      function (response) {
        console.error('Related products: Clerk.io error:', response);
      }
    );
  }

  loadSection(handles) {
    const url =
      window.location.pathname +
      '?sections=ro-related-products-content&handles=' +
      encodeURIComponent(handles.join(','));

    fetch(url)
    .then((response) => response.json())
    .then((data) => {
      // Insert the section content inside the container
      this.innerHTML = this.getSectionInnerHTML(data['ro-related-products-content']);
      // this.logProductClick();
    })
    .catch((error) => {
      console.error('Error loading the section:', error);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}
customElements.define('ro-related-products', RoRelatedProducts);
class RoComplementaryProducts extends RoRelatedProducts {

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  async fetch() {
    const slots = ['TOPS', 'BOTTOMS', 'ACCESSORIES', 'SHOES'];
    const color = this.dataset.productColor;
    const usedHandles = [];

    const clerkCall = (queryObj) => new Promise((resolve) => {
      Clerk('call', this.dataset.type, queryObj,
        (response) => resolve(response.product_data ?? []),
        () => resolve([])
      );
    });

    const fetchSlot = async (slotType) => {
      const filters = [`type = "${slotType}"`];
      if (color) filters.push(`generic_colors contains "${color}"`);

      const products = await clerkCall({
        key: this.dataset.ak,
        limit: 10,
        attributes: ['handle'],
        exclude: this.dataset.productId ? [this.dataset.productId] : null,
        products: this.dataset.productId ? [this.dataset.productId] : null,
        filter: filters.join(' and '),
      });

      const product = products.find(p => !usedHandles.includes(p.handle));
      if (product) usedHandles.push(product.handle);
      return product;
    };

    const results = await Promise.all(slots.map(fetchSlot));
    const handles = results.filter(Boolean).map(p => p.handle);

    this.loadSection(handles);
  }
}
customElements.define('ro-complementary-products', RoComplementaryProducts);